(ns ycweb.components.datatables.buttons
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as yuc]))

(def btn-lookup
  {:refresh
   {:text "Refresh"
    :action :datatables/refresh
    :config {:mode :read}}})

(rum/defc toolbar < rum/reactive
  [app-atom table-name selected-row-ids buttons table-fns]
  (let [action-atom (cmn/action-cursor app-atom)
        table-state (cmn/curact action-atom [:datatables table-name])
        select-all-active? (:select-all-active? table-state)]
    [:div
     (when buttons
       (into [:div.btn-toolbar {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}]
         (->>
           buttons
           (remove nil?)
           (map
             (fn [btn-config]
               (let [raw-data-override-fn (:raw-data-override-fn btn-config)

                     requires-row?
                     (and
                       (:extends btn-config)
                       (or
                         (= (:extends btn-config) :edit)
                         (= (:extends btn-config) :remove)))

                     disabled?
                     (or
                       (:disabled btn-config)
                       (and requires-row?
                         (or
                           (nil? selected-row-ids)
                           (empty? selected-row-ids)))
                       (and
                         requires-row?
                         (not (:multi-select btn-config))
                         (> (count selected-row-ids) 1)))

                     button-fns (get table-fns :button-fns)
                     component-fn (get button-fns (:component-fn btn-config))

                     extends (:extends btn-config)
                     toggle-select-all (= extends :toggle-select-all)

                     button-text
                     (cond
                       toggle-select-all
                       (if-not select-all-active? "Select All" "Deselect All")

                       :else
                       (:text btn-config))]

                 (cond
                   (:editor btn-config)
                   [:div
                    {:class (yuc/bem :flex-grid-block [:fluid])}
                    [:div.flex-grid-content
                     (buttons/button (:text btn-config)
                       #(grid/dispatch-action app-atom
                          (or (:action btn-config) :editor/open-modal)
                          (assoc btn-config
                            :selected-row-ids selected-row-ids
                            :editor-fns (:editor table-fns)))
                       (merge
                         {:primary true
                          :raised true
                          :disabled disabled?}
                         (:attr btn-config)))]]

                   extends
                   [:div
                    {:class (yuc/bem :flex-grid-block [:fluid])}
                    [:div.flex-grid-content
                     (buttons/button button-text
                       (cond
                         (:action btn-config)
                         #(grid/dispatch-action app-atom (:action btn-config)
                            (assoc (:config btn-config {})
                              :selected-row-ids selected-row-ids))

                         toggle-select-all
                         #(grid/dispatch-action app-atom :datatables/toggle-select-all
                            {:table-name table-name
                             :raw-data-override-fn raw-data-override-fn}))
                       (merge
                         {:primary true
                          :raised true
                          :disabled disabled?}
                         (:attr btn-config)))]]

                   (and
                     (:component-fn btn-config)
                     (nil? component-fn))
                   (toaster/open-toast app-atom :error (str "Button component not defined for: " (:text btn-config)) {})

                   (:component-fn btn-config)
                   (component-fn app-atom
                     {:table-name table-name
                      :selected-row-ids selected-row-ids})


                   (or (keyword? btn-config) (yuc/presence (:lookup btn-config)))
                   (let [btn-key (or (yuc/presence (:lookup btn-config)) btn-config)
                         btn (get btn-lookup btn-key)]
                     [:div
                      {:class (yuc/bem :flex-grid-block [:fluid])}
                      [:div.flex-grid-content
                       (buttons/button (:text btn)
                         (when (:action btn)
                           #(grid/dispatch-action app-atom (:action btn)
                              (merge
                                (assoc (or (:config btn) {})
                                  :table-name table-name
                                  :table-fns table-fns
                                  :selected-row-ids selected-row-ids)
                                (:attr btn-config))))
                         (merge
                           {:primary true
                            :raised true}
                           (:attr btn-config)))]])

                   :else
                   [:div
                    {:class (yuc/bem :flex-grid-block [:fluid])}
                    [:div.flex-grid-content
                     (buttons/button (:text btn-config)
                       (when (:action btn-config)
                         #(grid/dispatch-action app-atom (:action btn-config)
                            (assoc (or (:config btn-config) {})
                              :selected-row-ids selected-row-ids)))
                       (merge
                         {:primary true
                          :raised true
                          :disabled (:disabled btn-config)}
                         (:attr btn-config)))]])))))))]))